// extracted by mini-css-extract-plugin
export var locationCard = "_hf-0";